import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { CalendarioService } from '../../services/calendario.service';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';



@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css']
})
export class CalendarioComponent implements OnInit {

  tituloCard: string = 'Calendarios';
  tituloForm: string = 'Lista De Calendarios';

  formulario: FormGroup;
  formularioPeriodo: FormGroup;
  duplicarCalendario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  cmbMeses: { clave: number; valor: string; }[];

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;
  calendarioPeriodos = [];

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbSiNo: any[] = [
    {
      clave: 'SI',
      valor: 'SI'
    },
    {
      clave: 'NO',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _calendario: CalendarioService,
    private _catalogo: CatalogoIndicadoresService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idCalendario: ['', null],
      periodo: ['', [Validators.required]],
      totalMes: ['', []],
      totalDias: ['', []],
      predeterminado: ['', [Validators.required]],
      idVendedorTipo: ['', null],
      vendedorTipo: ['', null],
      descDuplicar: ['', null],
    });

    this.formularioPeriodo = this.fb.group({
      idCalendario: ['', []],
      mes: ['', [Validators.required]],
      dias: ['', [Validators.required, Validators.min(1), Validators.max(31)]],
    });

    this.duplicarCalendario = this.fb.group({
      duplicar: ['', [Validators.required]],
    });

    this.cargarGridcomponent();
    this.getCalendarios();

  }

  openModal() {
    console.log("openModal()")
    // document.getElementById('abrirModal').click();
    document.getElementById('fillOne').click();
  }

  closeModal() {
    document.getElementById('cerrarModalPeso').click();
  }

  /* FUNCIONES */

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idCalendario',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Periodo',
        field: 'periodo',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Meses Configurados',
        field: 'totalMes',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Total Días Calendario',
        field: 'totalDias',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Predeterminado',
        field: 'predeterminado',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  mesesDisponibles() {
    this.cmbMeses = this._catalogo.catalogoMeses();

    for (let i = 0; i < this.calendarioPeriodos.length; i++) {
      let index = this.cmbMeses.findIndex(e => e.clave == this.calendarioPeriodos[i].mes)
      if (index >= 0) {
        console.log("index", index);
        this.cmbMeses.splice(index, 1);
      }
    }
  }

  copiar() {

  }

  nuevo() {
    this.formulario.reset();
    this.formularioPeriodo.reset();
    this.calendarioPeriodos = [];
    this.mesesDisponibles();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Calendario';
  }

  listPeriodos;
  getPeriodo(idCalendario) {
    this._calendario.getPeriodo(idCalendario).subscribe((res: any[]) => {
      console.log("getPeriodo()", res)
      this.loading = false;
      this.calendarioPeriodos = res;
      this.mesesDisponibles();
    }, (err) => {
      this.loading = false;
      this.calendarioPeriodos = [];
      this.mesesDisponibles();
    });
  }

  editar({ rowData }) {

    console.log("rowData", rowData)

    this.formulario.reset();
    this.formularioPeriodo.reset();

    this.getPeriodo(rowData.idCalendario);

    this.formulario.setValue(rowData);
    document.getElementById('buttonAbrirModal').click();

  }

  acciones(event) {
    // debugger
    console.log("event", event)
    console.log("this.GUARDAR", this.GUARDAR)
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  accionesActualizar(event) {
    // debugger
    console.log("event", event)
    console.log("this.GUARDAR", this.GUARDAR)
    if (event === this.GUARDAR) {
      this.actualizar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    console.log("limpiarRegresar", event)
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Calendarios';
    this.tituloForm = 'Lista De Calendarios';
    document.getElementById('cerrarModal').click();
  }

  /** SERVICIOS */
  getCalendarios() {
    this.listaVacia = true;
    this.loading = true;

    this._calendario.getCalendarios().subscribe((res: any[]) => {
      console.log("getCalendarios()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;

      for (let i = 0; i < this.rowData.length; i++) {
        this.rowData[i].descDuplicar = "ID: " + this.rowData[i].idCalendario + " Año: " + this.rowData[i].periodo + " Dias: " + this.rowData[i].totalDias + " Meses: " + this.rowData[i].totalMes + " Predeterminado: " + this.rowData[i].predeterminado;
      }
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminarCalendario() {

    console.log("eliminarCalendario", this.rowData.filter(t => t.idCalendario == this.formulario.get('idCalendario').value)[0])
    let data = this.rowData.filter(t => t.idCalendario == this.formulario.get('idCalendario').value)[0];

    this.eliminar(this.rowData.filter(t => t.idCalendario == this.formulario.get('idCalendario').value)[0]);
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._calendario.deleteCalendario(data),
      })
      .then((res: any) => {
        this.getCalendarios();
        document.getElementById('cerrarModal').click();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminar({ rowData }) {

    console.log("rowData", rowData);
    let data = rowData;

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._calendario.deleteCalendario(data),
      })
      .then((res: any) => {
        this.getCalendarios();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  eliminarPeriodo(rowData) {

    let data = rowData;
    console.log("eliminarPeriodo", rowData)

    let mes = this.calendarioPeriodos.findIndex(e => e.mes == rowData.mes)
    if (mes >= 0) {
      console.log("mes", mes);
      this.calendarioPeriodos.splice(mes, 1);
    }

    this.mesesDisponibles();

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    datos.lsPeriodo = this.calendarioPeriodos;
    console.log("datos", datos);

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._calendario.saveCalendario(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getCalendarios();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  guardarPeriodo() {

    let data = this.formularioPeriodo.getRawValue();
    let calendario = this.formulario.getRawValue();

    data.idCalendario = calendario.idCalendario;

    let mes = this.cmbMeses.findIndex(e => e.clave == data.mes)
    console.log("mes", mes);
    if (mes >= 0) {
      this.cmbMeses[mes].valor;
      data.mesDescripcion = this.cmbMeses[mes].valor.toUpperCase();
    }

    this.calendarioPeriodos.push(data);
    this.formularioPeriodo.reset();
    this.mesesDisponibles();

  }

  guardarPeriodoLocal() {

  }

  actualizar() {
    console.log("actualizar", this.formulario.getRawValue())
    console.log("calendarioPeriodos", this.calendarioPeriodos)

    let dias = 0;
    let data = this.formulario.getRawValue();

    for (let i = 0; i < this.calendarioPeriodos.length; i++) {
      dias = dias + this.calendarioPeriodos[i].dias;
    }

    data.totalDias = dias;
    data.lsPeriodo = this.calendarioPeriodos;
    data.totalMes = this.calendarioPeriodos.length;

    console.log("actualizar data", data);

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._calendario.updateCalendario(data),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getCalendarios();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  duplicar() {

    let idCalendario = this.duplicarCalendario.getRawValue();
    let id = this.rowData.findIndex(e => e.idCalendario == idCalendario.duplicar);
    let calendario = this.rowData[id];

    console.log("calendario", calendario);
    if (id >= 0) {
      this._utils.confirmarSincronoPromesa(
        {
          title: this.DAT_MSG.actualizar,
          text: '',
          action: this.DAT_BTNS.actualizar,
          funcion: this._calendario.duplicarCalendario(calendario),
          loading: true,
          context: this,
        }
      ).then((res: any) => {
        this.getCalendarios();
        document.getElementById('cerrarModalPeso').click();
      }).catch((err) => {
        console.log(err);
        // this._utils.mensajeErroToast(err.error.message, 5000);
      });
    }
  }

}
